__turbopack_context__.v({
  "icon": "svg-icon-module-scss-module__OU6-0a__icon",
});
